import React from 'react';
import * as Icons from 'lucide-react';
import { useSettings } from '../context/SettingsContext';
import { resolveImageUrl } from './ImageUpload';

// Built-in fallback used only if admin hasn't customised the list
const DEFAULTS = [
  { id: 'p1', icon: 'Truck', title: 'Scheduled delivery', desc: 'Weekly or on-demand routes across Muscat', color: '#0078D4', bg: '#DEECF9', image: '' },
  { id: 'p2', icon: 'FileText', title: 'Tax invoices ready', desc: 'VAT-compliant invoices on every order', color: '#7C3AED', bg: '#EDE9FE', image: '' },
  { id: 'p3', icon: 'Wallet', title: 'Trade pricing', desc: 'Volume discounts for verified businesses', color: '#10B981', bg: '#D1FAE5', image: '' },
  { id: 'p4', icon: 'Calendar', title: 'Same-day dispatch', desc: 'Orders placed before 14:00 ship today', color: '#0EA5E9', bg: '#E0F2FE', image: '' },
];

const BrandPromise = () => {
  const { settings } = useSettings();
  const items =
    settings?.brand_promises && settings.brand_promises.length > 0
      ? settings.brand_promises
      : DEFAULTS;

  return (
    <section className="bg-white py-12 sm:py-16 border-t border-slate-100">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-10">
          <div className="text-[11px] font-bold tracking-[0.2em] text-[#0078D4] uppercase mb-2">
            {settings?.promises_eyebrow || 'Why mrpco'}
          </div>
          <h2 className="font-display text-3xl sm:text-4xl text-slate-900">
            {settings?.promises_heading || 'Built for businesses that order in volume'}
          </h2>
        </div>
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-4 lg:gap-6">
          {items.map((p) => {
            const Icon = Icons[p.icon] || Icons.Truck;
            const img = resolveImageUrl(p.image);
            return (
              <div key={p.id || p.title} className="rounded-2xl border border-slate-100 bg-white card-lift overflow-hidden">
                {img && (
                  <div
                    className="aspect-[16/9] w-full overflow-hidden"
                    style={{ background: p.bg }}
                  >
                    <img src={img} alt="" className="w-full h-full object-cover" />
                  </div>
                )}
                <div className="p-5">
                  <div
                    className="w-11 h-11 rounded-xl flex items-center justify-center mb-4"
                    style={{ background: p.bg }}
                  >
                    <Icon className="w-5 h-5" style={{ color: p.color }} />
                  </div>
                  <div className="font-display text-base sm:text-lg leading-tight text-slate-900">{p.title}</div>
                  <div className="text-xs sm:text-sm text-slate-600 mt-1">{p.desc}</div>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default BrandPromise;
